import { ICompanyState } from '@/shared/store/company/company.interfaces'

export default (): ICompanyState => ({
  company: null,
  loading: true
})
